import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-phone-number',
  styleUrl: 'address.css',
  shadow: true,
})
export class Phone {
  @Prop() phoneLabel: string = "Phone";
  @Prop() phoneNum: string = "216.368.2000";

  render() {
    return (
      <div class="phone-full">
         <p class="contact phone-number">{`${this.phoneLabel}`}: <a href={`tel:${this.phoneNum}`}>{this.phoneNum}</a></p>
      </div>
    );
  }
}
